import { render, staticRenderFns } from "./MetricsChartCard.vue?vue&type=template&id=3dd5d1fe&scoped=true"
import script from "./MetricsChartCard.vue?vue&type=script&lang=js"
export * from "./MetricsChartCard.vue?vue&type=script&lang=js"
import style0 from "./MetricsChartCard.vue?vue&type=style&index=0&id=3dd5d1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd5d1fe",
  null
  
)

export default component.exports